import { useState, useEffect } from "react";
import { Button } from "./ui/button";
import { X } from "lucide-react";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookie_consent", "accepted");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-md z-50 shadow-2xl rounded-2xl p-5"
      style={{ backgroundColor: "#FFFFFF", border: "1px solid rgba(26, 33, 24, 0.08)" }}
      data-testid="cookie-banner"
    >
      <div className="flex items-start gap-3">
        <div className="flex-1 text-sm" style={{ color: "#1A2118" }}>
          <p className="font-bold mb-1">Sīkdatnes</p>
          <p style={{ color: "#475545" }}>
            Mēs izmantojam tikai tehniski nepieciešamās sīkdatnes lapas
            darbībai. Vairāk informācijas{" "}
            <a
              href="/privatuma-politika"
              className="underline"
              style={{ color: "#27A64C" }}
            >
              privātuma politikā
            </a>
            .
          </p>
        </div>
        <button
          onClick={handleAccept}
          className="p-1 hover:opacity-70 transition-opacity"
          data-testid="cookie-banner-close"
          aria-label="Aizvērt"
        >
          <X className="h-4 w-4" style={{ color: "#475545" }} />
        </button>
      </div>
      <Button
        onClick={handleAccept}
        data-testid="cookie-banner-accept"
        className="w-full mt-4 text-white rounded-full font-bold"
        style={{ backgroundColor: "#27A64C" }}
      >
        Sapratu
      </Button>
    </div>
  );
};

export default CookieBanner;
